import { useRouter } from 'next/router';
import { useBannerContext } from '@/contexts/BannerContext';
import useCookie from '@ui-components/hooks/useCookie';
import { useEffect } from 'react';

const BANNER_HIDE_KEY = 'banner_hide_until';


export const useBannerVisibility = () => {
  const router = useRouter();
  const { isVisible, setIsVisible } = useBannerContext();
  const { setCookie, getCookie } = useCookie();
  // 페이지 진입시 쿠키 체크하여 배너 상태 초기화
  useEffect(() => {
    if (isHideExpired()) {
      setIsVisible(true);
    }
  }, [router.pathname]);
  
  const isHideExpired = () => {
    return !getCookie(BANNER_HIDE_KEY);
  };

  const hideTemporary = () => {
    setIsVisible(false);
  };

  const hideForWeek = () => {
    setCookie(BANNER_HIDE_KEY, 'true', 7);
    setIsVisible(false);
  };

  const showBanner = router.pathname.endsWith('/credit') && isVisible && isHideExpired();

  return { showBanner, hideBanner: hideTemporary, hideForWeek };
};